import LottieAnimation from '../shared/components/animation';
import AutoSizeTextarea from '../shared/components/auto-size-textarea';
import ComponentManager from '../shared/component-manager';
import FormEditAvatar from '../shared/components/form-edit-avatar';
import NonBlankForm from '../shared/components/non-blank-form';
import GoogleTagManager from '../shared/components/google-tag-manager';
import OffsetAnchor from '../shared/components/offset-anchor';
import PhotoUploader from '../shared/components/photo-uploader';
import RemoteReloadingElement from '../shared/components/remote-reloading-element';
import Sidebar from '../shared/components/sidebar';
import SidebarToggle from '../shared/components/sidebar-toggle';
import SingleSubmitForm from '../shared/components/single-submit-form';
import SwipeableCards from '../shared/components/swipeable-cards';
import TooltipTrigger from '../shared/components/tooltip-trigger';
import WaitingBarOverlay from '../shared/components/waiting-bar-overlay';
import SchoolField from '../shared/components/school-field';
import NavigationSelect from '../shared/components/navigation-select';

import AchievementOnboardingActionButton from './components/achievements/achievement-onboarding-action-button';
import BadgeCounter from './components/badge-counter';
import ClickElement from './components/click-element';
import CommentButton from './components/comment-button';
import CommentForm from './components/comment-form';
import ContactMentorPopup from './components/mentee/contact-mentor-popup';
import ContentSidebar from './components/content-sidebar';
import DeleteAccountModal from './components/delete-account-modal';
import EventList from './components/event-list';
import FacebookSender from './components/facebook-sender';
import FeaturedRecordsCarousel from './components/featured-records-carousel';
import FlaggingContainer from './components/flagging-container';
import FlaggingForm from './components/flagging-form';
import FullHeightWindow from './components/full-height-window';
import HoverableElement from './components/hoverable-element';
import InternshipCancelModal from './components/internship-cancel-modal';
import InternshipRatingForm from './components/internship-rating-form';
import InternshipResponse from './components/internship-response';
import InviteModal from './components/invite-modal';
import LikeButton from './components/like-button';
import LocallySavedTextInput from './components/locally-saved-text-input';
import MentorMessageForm from './components/mentor-message-form';
import MentorSmsModal from './components/mentor/mentor-sms-modal';
import MentorUnavailabilityModal from './components/mentor/mentor-unavailability-modal';
import MentorWelcomeModal from './components/mentor-welcome-modal';
import NewlyCompletedBadgesModal from './components/achievements/newly-completed-badges-modal';
import OnboardingSplash from './components/onboarding-splash';
import OnboardingTiles from './components/onboarding-tiles';
import PartnersRotator from './components/partners-rotator';
import Popover from './components/popover';
import ProxyAttachmentReloader from './components/proxy-attachment-reloader';
import ReloadPageLink from './components/reload-page-link';
import ResponsivePlaceholder from './components/responsive-placeholder';
import StarRating from './components/star-rating';
import StickyNavbar from './components/sticky-navbar';
import TeacherUpdateOccupationModal from './components/teacher-update-occupation-modal';
import UserQuickInfos from './components/user-quick-infos';
import LogoutLink from './components/logout-link';
import PopupLink from './components/popup-link';
import RegionDropdown from '../shared/components/region-dropdown';
import AutoSubmitInput from '../shared/components/auto-submit-input';
import MoreMentorsButton from './components/more-mentors-button';

class AppComponentManager extends ComponentManager {
  initializeComponents() {
    AchievementOnboardingActionButton.initialize(
      '.achievementOnboarding-outgoing-action'
    );
    AutoSizeTextarea.initialize('.autoSizeTextarea');
    BadgeCounter.initialize('.badgeCounter', {
      badges: {
        unreadMessage: '.unreadMessageBadge',
      },
    });
    ClickElement.initialize('.clickElement');
    CommentButton.initialize('.commentButton');
    CommentForm.initialize('.commentForm');
    ContactMentorPopup.initialize('.contactMentorPopup');
    ContentSidebar.initialize('.contentSidebar');
    DeleteAccountModal.initialize('.deleteAccountModal');
    EventList.initialize('.eventList');
    FacebookSender.initialize('.facebookSender');
    FeaturedRecordsCarousel.initialize('.featuredRecordsCarousel');
    FormEditAvatar.initialize('.formEditAvatar');
    FullHeightWindow.initialize('.groupCards');
    GoogleTagManager.initialize('body');
    SchoolField.initialize('.schoolField');
    NavigationSelect.initialize('.navigationSelect');
    HoverableElement.initialize('.hoverableElement');
    InternshipCancelModal.initialize('.internshipCancelModal');
    InternshipRatingForm.initialize('.internshipRatingForm');
    InternshipResponse.initialize('.internshipResponse');
    InviteModal.initialize('.inviteModal');
    LikeButton.initialize('.likeButton');
    LocallySavedTextInput.initialize('.locallySavedTextInput');
    LottieAnimation.initialize('.lottieAnimation');
    MentorMessageForm.initialize('.mentorshipRequest');
    MentorUnavailabilityModal.initialize('.unavailabilityModal');
    MentorSmsModal.initialize('.mentorSmsModal');
    MentorWelcomeModal.initialize('.mentorWelcomeModal');
    NewlyCompletedBadgesModal.initialize('.newlyCompletedBadgesModal');
    NonBlankForm.initialize('.nonBlankForm');
    OffsetAnchor.initialize('.offsetAnchor');
    OnboardingSplash.initialize('.onboardingSplash');
    OnboardingTiles.initialize('.onboardingTiles');
    PartnersRotator.initialize('.partners');
    PhotoUploader.initialize('.photoUploader');
    Popover.initialize('.popover');
    ProxyAttachmentReloader.initialize('.proxyAttachment--unextracted');
    ReloadPageLink.initialize('.reloadPageLink');
    RemoteReloadingElement.initialize('.remoteReloadingElement');
    ResponsivePlaceholder.initialize('.responsivePlaceholder');
    StickyNavbar.initialize('.sticky-navbar', '.sticky-navbar-scroller');
    Sidebar.initialize('.sidebar-wrapper');
    SidebarToggle.initialize('.sidebarToggle');
    SingleSubmitForm.initialize('.singleSubmitForm');
    StarRating.initialize('.starRating');
    SwipeableCards.initialize('.swipeableCards');
    TeacherUpdateOccupationModal.initialize('.teacherUpdateOccupationModal');
    TooltipTrigger.initialize('.tooltipTrigger');
    UserQuickInfos.initialize('.userQuickInfos');
    WaitingBarOverlay.initialize('.waitingBarOverlay');
    LogoutLink.initialize('.dropdown-menu-item-link--logout');
    PopupLink.initialize('.popup-link');
    RegionDropdown.initialize('.search-form-dependency');
    AutoSubmitInput.initialize('.refreshable-input');
    MoreMentorsButton.initialize('#home-more-mentors');

    // There’s only one .flagItem element in the DOM,
    // this is why we pass flaggingForm[0] to FlaggingContainer.
    const flaggingForm = FlaggingForm.initialize('.flagItem');
    FlaggingContainer.initialize('.flaggableContainer', {
      flaggingForm: flaggingForm[0],
    });
  }
}

export const initialize = () => {
  jQuery(() => {
    // When the wrapper has the container mode modifier, it means
    // that the page has been served with the CONTAINER_MODE header.
    const isContainerMode = $('.wrapper--container-mode').length;

    if (isContainerMode && window.ahoy) {
      window.ahoy.configure({platform: 'App'});
    }

    // Start the visit tracker
    if (window.ahoy) window.ahoy.start();

    new AppComponentManager([
      AchievementOnboardingActionButton,
      AutoSizeTextarea,
      BadgeCounter,
      ClickElement,
      CommentButton,
      CommentForm,
      ContentSidebar,
      DeleteAccountModal,
      EventList,
      FacebookSender,
      FeaturedRecordsCarousel,
      FormEditAvatar,
      FullHeightWindow,
      GoogleTagManager,
      SchoolField,
      NavigationSelect,
      HoverableElement,
      InternshipCancelModal,
      InternshipRatingForm,
      InternshipResponse,
      InviteModal,
      LikeButton,
      LocallySavedTextInput,
      LottieAnimation,
      MentorMessageForm,
      MentorWelcomeModal,
      NewlyCompletedBadgesModal,
      NonBlankForm,
      OffsetAnchor,
      OnboardingSplash,
      OnboardingTiles,
      PartnersRotator,
      PhotoUploader,
      Popover,
      ProxyAttachmentReloader,
      ReloadPageLink,
      RemoteReloadingElement,
      ResponsivePlaceholder,
      Sidebar,
      SidebarToggle,
      SingleSubmitForm,
      StarRating,
      SwipeableCards,
      TeacherUpdateOccupationModal,
      TooltipTrigger,
      UserQuickInfos,
      WaitingBarOverlay,
      LogoutLink,
      FlaggingForm,
      FlaggingContainer,
      PopupLink,
      RegionDropdown,
      AutoSubmitInput,
      MoreMentorsButton,
    ]);
  });
};
